// eslint-disable-next-line import/no-unresolved
module.exports = require('./dist/index.js').default;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-with-styles-interface-css/index.js
 ** module id = 1347
 ** module chunks = 0
 **/